<template>
  <v-layout align-center justify-center row fill-height wrap>
    <v-flex xs9 sm4 md3 lg3 xl2>
      <div class="image-container">
        <img src="@/assets/images/maple-logo.png" class="image"/>
      </div>
      <v-form @submit.prevent="login" novalidate>
        <v-text-field
          v-model="email"
          label="E-mail"
          :rules="[rules.required, rules.email]"
          ml-1 required
          data-test="email"
        />
        <v-text-field
          v-model="password"
          :append-icon="showPassword ? 'visibility_off' : 'visibility'"
          :type="showPassword ? 'text' : 'password'"
          :rules="[rules.required]"
          label="Senha"
          @click:append="showPassword = !showPassword"
          data-test="password"
        />
        <v-btn class="mt-2" block type="submit" :disabled="disabledButton" color="primary" data-test="button-login" :loading="isLoginButtonLoading">
          Login
        </v-btn>
        <div class="link mt-3">
          <a :href="forgotPasswordUrl">Esqueci minha senha</a>
        </div>
      </v-form>
    </v-flex>
  </v-layout>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import { email } from '@/helpers/regex'

export default {
  name: 'auth-login',

  data: () => ({
    email: null,
    password: null,
    showPassword: false,
    rules: {
      required: value => !!value || 'Obrigatório',
      email: value => email.test(value) || 'Invalido.'
    },
    timeCount: 5
  }),

  computed: {
    ...mapState({
      loginError: state => (state.auth.loginError),
      loginSuccess: state => (state.auth.loginSuccess),
      isLoginButtonLoading: state => (state.auth.isLoginButtonLoading),
      updateExists: state => (state.swUpdate.updateExists)
    }),

    disabledButton () {
      return (
        !this.email ||
        !this.password ||
        !email.test(this.email) ||
        this.isLoginButtonLoading
      )
    },

    forgotPasswordUrl () {
      return '/account_recovery'
    }
  },

  watch: {
    loginError (newValue) {
      if (newValue) {
        this.showSnack(newValue)
      }
    },
    async loginSuccess (newValue) {
      if (newValue) {
        this.$router.push('/')
      }
    }
  },

  beforeDestroy () {
    this.resetLoginData()
  },

  methods: {
    ...mapActions({
      doLogin: 'auth/login',
      showSnack: 'snackbar/showSnack',
      resetLoginData: 'auth/resetLoginData'
    }),
    login () {
      const { email, password } = this
      this.doLogin(
        {
          credentials: { email, password }
        }
      )
    }
  }
}
</script>

<style lang="stylus" scoped>
  .link
    text-align center
    display block
  .image
    width 100%
    height 100%
    background-position center center
    background-repeat no-repeat
    &-container
      display block
      text-align center
</style>
